import { getMessages } from '../../../../../../../store/constants';

export const CARD_DATES_FROM_SUBCARD = getMessages().getText('card_form_dates_subcard_name');
export const CARD_DATES_FROM_CHECKITEM = getMessages().getText('card_form_dates_checkitem_name');
